// extracted by mini-css-extract-plugin
export var comingSoonMenu = "styles-module--comingSoonMenu--4cb7d";
export var contactContainer = "styles-module--contact-container--cda29";
export var contactItem = "styles-module--contact-item--766a0";
export var contactItemContent = "styles-module--contact-item-content--c2975";
export var contactItemHead = "styles-module--contact-item-head--fa384";
export var footerMainContainer = "styles-module--footer-main-container--44961";
export var linksContainer = "styles-module--links-container--77293";
export var news = "styles-module--news--f3fd8";
export var newsContainer = "styles-module--news-container--2845b";
export var newsItem = "styles-module--news-item--c3afd";
export var newsItemContent = "styles-module--news-item-content--f5b89";
export var standardLink = "styles-module--standardLink--4efdd";
export var thumbnail = "styles-module--thumbnail--c781f";